import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import ServiciosHero from './components/ServiciosHero';
import ServiciosDetalle from './components/ServiciosDetalle';
import ProcesoSection from './components/ProcesoSection';
import FaqSection from './components/FaqSection';
import { updatePageSEO } from '../../utils/seoConfig';

const ServiciosPage = () => {
  useEffect(() => {
    updatePageSEO('servicios');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServiciosHero />
        <ServiciosDetalle />
        <ProcesoSection />
        <FaqSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default ServiciosPage;
